<section class="hemenSat">
  <div class="container">
    <div class="row">
      <div class="col-md-12 tac">

        <h1 class="ml9">
          <a href="https://hemensat.cardata.com.tr/" target="_blank">
            <span class="text-wrapper">
              <span class="letters">Aracınızı değerinde hemen satın alıyoruz!</span>
            </span>
          </a>
        </h1>

        <script src="https://cdnjs.cloudflare.com/ajax/libs/animejs/2.0.2/anime.min.js"></script>
        <script>
          // Wrap every letter in a span
          var textWrapper = document.querySelector('.ml9 .letters');
          textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");

          anime.timeline({ loop: true })
            .add({
              targets: '.ml9 .letter',
              scale: [0, 1],
              duration: 1500,
              elasticity: 600,
              delay: (el, i) => 45 * (i + 1)
            }).add({
              targets: '.ml9',
              opacity: 0,
              duration: 1000,
              easing: "easeOutExpo",
              delay: 1000
            });
        </script>
      </div>
    </div>
  </div>
</section>